import type { Resource } from './types';

export const resourcesVideo: Resource[] = [
  {
    id: 'v-city-night',
    title: '城市夜景延时摄影合集',
    category: 'video',
    subCategory: 'film',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20long%20exposure%20city%20skyline%20at%20night%20with%20glowing%20teal%20and%20amber%20light%20trails%20over%20a%20river%2C%20stylized%20digital%20illustration%2C%20moody%20atmospheric%20tones%2C%20high%20detail%2C%20elegant%20editorial%20poster%20style%2C%20cool%20and%20warm%20contrast&width=800&height=500&seq=cov-v1&orientation=landscape',
    summary: '精选全球 20 座城市的夜景延时片段，光影流动，节奏舒缓，适合放松观看。',
    description: '本合集收录来自东京、上海、纽约、伊斯坦布尔等 20 座城市的夜景延时摄影作品，全部为高清免费素材。影片以舒缓的节奏串联城市从黄昏到深夜的光影变化，配合氛围音乐，呈现都市独有的浪漫质感。适合作为放松观赏或屏幕动态壁纸使用，也欢迎创作者下载片段用于二次创作。',
    author: '光影旅社',
    source: '免费91 编辑精选',
    publishedAt: '2026-09-28',
    views: 48210,
    favorites: 3120,
    tags: ['城市', '延时摄影', '4K', '氛围'],
    duration: '42:15',
  },
  {
    id: 'v-doc-earth',
    title: '自然纪录片《地球脉动》精选',
    category: 'video',
    subCategory: 'doc',
    cover: 'https://readdy.ai/api/search-image?query=Sweeping%20stylized%20nature%20documentary%20poster%20of%20green%20mountains%20and%20misty%20valley%20at%20sunrise%2C%20painterly%20digital%20art%2C%20soft%20golden%20light%2C%20lush%20textures%2C%20harmonious%20composition%2C%20elegant%20editorial%20look%2C%20cool%20and%20warm%20color%20balance&width=800&height=500&seq=cov-v2&orientation=landscape',
    summary: '豆瓣高分自然纪录片精选片段，带你领略地球上最壮丽的自然奇观。',
    description: '本页面精选自然纪录片《地球脉动》中最震撼的片段，涵盖极地冰川、热带雨林、深海珊瑚与非洲草原等经典场景。每一帧都达到电影级画质，解说娓娓道来，兼具科学性与观赏性。既适合自然爱好者收藏，也适合作为地理、生物课堂的辅助素材。',
    author: '纪录片之家',
    source: '免费91 编辑精选',
    publishedAt: '2026-09-20',
    views: 39680,
    favorites: 2870,
    tags: ['纪录片', '自然', '科普'],
    duration: '58:40',
  },
  {
    id: 'v-anime-rain',
    title: '治愈动画短片《雨巷》',
    category: 'video',
    subCategory: 'short',
    cover: 'https://readdy.ai/api/search-image?query=Dreamy%20anime%20short%20film%20poster%20of%20a%20girl%20with%20umbrella%20standing%20in%20a%20rain%20soaked%20alley%2C%20soft%20watercolor%20digital%20illustration%2C%20teal%20and%20warm%20orange%20highlights%2C%20gentle%20bokeh%20light%2C%20emotional%20calm%20mood%2C%20high%20detail&width=800&height=500&seq=cov-v3&orientation=landscape',
    summary: '一部讲述城市孤独与温柔的原创动画短片，画风细腻，时长 8 分钟。',
    description: '《雨巷》是一部独立制作的治愈系动画短片，讲述一位女孩在雨夜偶遇流浪猫的温暖故事。短片以手绘水彩风格呈现，配乐轻柔，几乎没有对白，却能让人安静下来。本片由国内独立动画团队免费发布，欢迎在观看后留下你的一句感想。',
    author: '雨巷动画工作室',
    source: '创作者免费发布',
    publishedAt: '2026-09-12',
    views: 27430,
    favorites: 2210,
    tags: ['动画', '治愈', '原创短片'],
    duration: '08:24',
  },
  {
    id: 'v-open-ai',
    title: '名校公开课：人工智能入门',
    category: 'video',
    subCategory: 'open',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20illustration%20about%20artificial%20intelligence%20with%20glowing%20neural%20network%20nodes%20in%20teal%20green%2C%20warm%20orange%20accents%2C%20dark%20clean%20background%2C%20geometric%20shapes%2C%20minimal%20editorial%20poster%20style%2C%20high%20detail&width=800&height=500&seq=cov-v4&orientation=landscape',
    summary: '面向零基础学习者的人工智能通识课，共 12 讲，中文配音，免费开放。',
    description: '本课程由高校人工智能实验室出品，面向零基础学习者系统讲解人工智能的基本概念、发展历程、典型应用与伦理议题。全课共 12 讲，每讲约 30 分钟，配有讲义与思考题。课程不要求编程基础，帮助你建立对这一领域的整体认知，适合学生与职场人士自学。',
    author: '启明大学 AI 实验室',
    source: '公开课免费授权',
    publishedAt: '2026-09-05',
    views: 51280,
    favorites: 4160,
    tags: ['公开课', '人工智能', '通识'],
    duration: '12 讲',
  },
  {
    id: 'v-travel-4k',
    title: '4K 自由行旅行大片精选',
    category: 'video',
    subCategory: 'film',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20travel%20photography%20poster%20of%20dramatic%20mountain%20coastline%20with%20turquoise%20sea%20and%20warm%20sunset%20light%2C%20fresh%20minimal%20digital%20illustration%2C%20layered%20landscape%2C%20airy%20composition%2C%20high%20detail%2C%20harmonious%20tones&width=800&height=500&seq=cov-v5&orientation=landscape',
    summary: '跟着镜头云游世界，精选海岛、雪山与古镇的 4K 旅行影像。',
    description: '本合集收录多段 4K 旅行影像，从北欧峡湾到东南亚海岛，从川西雪山到江南古镇，画面通透、色彩自然。每段影像都标注了拍摄地点与最佳旅行季节，既可用于云旅行放松，也能为你的行程规划提供灵感。全部素材免费观看，禁止商用。',
    author: '在路上影像',
    source: '免费91 编辑精选',
    publishedAt: '2026-08-30',
    views: 33560,
    favorites: 1980,
    tags: ['旅行', '4K', '风光'],
    duration: '36:50',
  },
  {
    id: 'v-anime-shanhai',
    title: '国漫推荐《山海少年》',
    category: 'video',
    subCategory: 'anime',
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20Chinese%20fantasy%20animation%20poster%20with%20a%20young%20hero%20and%20mythical%20beasts%20under%20a%20glowing%20sky%2C%20rich%20teal%20green%20and%20warm%20amber%20palette%2C%20stylized%20digital%20painting%2C%20epic%20composition%2C%20high%20detail&width=800&height=500&seq=cov-v6&orientation=landscape',
    summary: '年度口碑国漫，改编自山海经神话，画面精美，目前已更新 12 集。',
    description: '《山海少年》是一部以《山海经》为灵感创作的国产奇幻动画，讲述了少年与神兽伙伴一同守护家园的冒险故事。作品在美术、分镜与配乐上都达到较高水准，上线后口碑持续走高。本页汇总了前 12 集的免费观看入口与剧情简介，适合喜欢国风与奇幻题材的观众。',
    author: '山海动画',
    source: '官方免费播出',
    publishedAt: '2026-08-22',
    views: 62140,
    favorites: 5240,
    tags: ['国漫', '奇幻', '连载'],
    duration: '12 集',
  },
  {
    id: 'v-food-doc',
    title: '经典纪录片《舌尖上的风味》',
    category: 'video',
    subCategory: 'doc',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20documentary%20poster%20of%20steaming%20Chinese%20dishes%20on%20a%20rustic%20wooden%20table%2C%20soft%20golden%20light%2C%20teal%20and%20amber%20accents%2C%20appetizing%20editorial%20food%20photography%20style%2C%20cozy%20atmosphere%2C%20high%20detail&width=800&height=500&seq=cov-v7&orientation=landscape',
    summary: '透过一道道家常菜，讲述中国人餐桌上的故事与乡愁。',
    description: '本片以食物为线索，走访大江南北的普通家庭，记录食材从田间到餐桌的全过程。它讲的不只是味道，更是人与土地、与家人之间的情感联结。全季免费观看，适合在饭点与家人一起欣赏，也非常适合作为美食类内容创作者的参考素材。',
    author: '风味纪实',
    source: '免费91 编辑精选',
    publishedAt: '2026-08-15',
    views: 45870,
    favorites: 3560,
    tags: ['纪录片', '美食', '人文'],
    duration: '7 集',
  },
];